<template>
    <div class="d-inline-block">
        <slot></slot>

        <div class="modal fade signal-error-modal" id="signalAbuse" tabindex="-1" aria-labelledby="signalAbuseLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content modal-block">
                    <div class="modal-close-button box-shadow">
                        <button type="button" class="btn-close btn-close-white p-2" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body modal-block-content mx-auto box-shadow position-relative">
                        <div class="line line-left">
                            <label class="h2-like bg-white-like" for="message">{{ title }}</label>
                        </div>

                        <form v-if="!validated" @submit.prevent="sendReport">
                            <div v-for="error of errors" class="mb-3">
                                <p class="bg-darkRed text-white mb-1 px-2 py-1" v-if="error">{{ error[0] }}</p>
                            </div>

                            <textarea name="message" id="message" cols="" rows="7" placeholder="Laissez votre adresse e-mail si vous souhaitez une réponse." class="w-100 mb-3 lh-sm" v-model="message"></textarea>

                            <button class="btn btn-red px-5 pt-1" type="submit">Envoyer</button>
                        </form>

                        <div v-if="validated">
                            <p>Votre message a bien été pris en compte, merci !</p>

                            <button class="btn btn-red px-5 pt-1" data-bs-dismiss="modal" @click="resetModal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: String,
    },

    data() {
        return {
            message: null,
            url: null,
            errors: {
                text: null,
                url: null
            },
            validated: false,
        }
    },

    mounted() {
        this.url = window.location.href
    },

    methods: {
        sendReport() {
            axios.post(`/report/store`, {message: this.message, url: this.url})
                .then((response) => {
                    this.validated = true
                })
                .catch((error) => {
                    let errors = error.response.data.errors
                    for (const [error_item_key, error_item] of Object.entries(errors)) {
                        this.errors[error_item_key] = error_item
                    }
                })
        },

        resetModal() {
            this.validated = false
            this.message = null
        }
    }
};
</script>
